import { Component } from "@angular/core";
import { OnfidoService } from "../../services/onfido.service";

@Component({
	selector: "onfido-close-popup",
	templateUrl: "./onfido-close-popup.component.html",
	styleUrls: ["./onfido-close-popup.component.scss"],
	standalone: false
})
export class OnfidoClosePopupComponent {
	private isClosePopupVisible: boolean = false;

	public constructor(private onfidoService: OnfidoService) {
		this.onfidoService.getModalCloseClick().subscribe((b) => (this.isClosePopupVisible = b));
	}

	public answer(b: boolean): void {
		this.onfidoService.onModalCloseResponse(b);
	}

	public showClosePopup(): boolean {
		return this.isClosePopupVisible;
	}
}
